import React, { useEffect, useRef, useState } from 'react';
import { ITeamMember } from '@incentivegames/ig-types/lib/interfaces/apiContracts';
import { useTranslation } from 'react-i18next';

import { calcNewSigningFooterProps } from '../NewSigningCardFooter/NewSigningCardFooterFunctions';
import GameCardContainer from 'components/GameCardContainer';
import NewSigningCard from '../NewSigningCard';
import RestrictedContainer from 'components/RestrictedContainer';
import NewSigningHeader from '../NewSigningHeader';
import './NewSigningSelect.scss';

export interface INewSigningSelectProps {
  team: ITeamMember[];
  onConfirmSwap: (selnNum: number) => void;
  initialSelection?: number;
}

const NewSigningSelect: React.FC<INewSigningSelectProps> = ({ team, onConfirmSwap, initialSelection }) => {
  const { t } = useTranslation();
  const [selectionNumber, setSelectionNumber] = useState(initialSelection);

  const onPlayerSelect = (seln: number) => {
    if (seln === selectionNumber) setSelectionNumber(undefined);
    else setSelectionNumber(seln);
  };

  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (selectionNumber !== undefined) buttonRef.current?.classList.add('new-signing-select__swap-button--visible');
  }, [selectionNumber]);

  return (
    <RestrictedContainer>
      <NewSigningHeader />
      <GameCardContainer>
        {team.map((teamMember) => (
          <NewSigningCard
            key={teamMember.selnNumber}
            selected={selectionNumber === teamMember.selnNumber}
            onPlayerSelect={() => onPlayerSelect(teamMember.selnNumber)}
            footerDetails={calcNewSigningFooterProps(teamMember)}
            {...teamMember}
          />
        ))}
      </GameCardContainer>
      {selectionNumber !== undefined && (
        <button ref={buttonRef} className="new-signing-select__swap-button" onClick={() => onConfirmSwap(selectionNumber)}>
          {t('swap')}
        </button>
      )}
    </RestrictedContainer>
  );
};

export default NewSigningSelect;
